import React from "react";
import "../widgets.scss";
import "../radialgauge.scss";
import wrapWidget from "../WidgetHOC";
import wrapMockedWidget from "../MockedWidgetHOC";

import { lightColor } from "../../../../../helpers/colors";

import { arc, text } from "d3-shape";
import { scaleLinear } from "d3-scale";

const BASE_RAD = 30;
const TRACK_W = 3;
const START_ANGL = 120;
const END_ANGL = START_ANGL;
const CY = 63;

//const TEMPORARY_LOW_LIMIT_REL = 0.5;
//const TEMPORARY_HIGH_LIMIT_REL = 0.75;
const RadialGauge = props => {
  let {
    liveSensorValue,
    //resolvedSensorConfig,
    thisWidgetConfig,
    widgetColor
  } = props;

  // light color
  let _lightWidgetColor = lightColor(widgetColor);


  // 

 // console.log("88", props.coords);
  // TODO: make text scaling non linear!
  // read props.coords to find out width/height of widget. use the larger one
  // make text size/scaling proportional to this value, but contrain it to upper, lower bounds!

  let { widgetSettings = {} } = thisWidgetConfig;

  let sensorValue = 0;
  //let sensorUnit = "";

  try {
    sensorValue = (liveSensorValue && liveSensorValue.value) || 0;
    sensorValue = parseFloat(sensorValue).toFixed(2);
  } catch (error) {
    console.error(error);
  }

  let max = parseFloat(widgetSettings.max_value) || 100;
  let min = parseFloat(widgetSettings.min_value) || 0;
  let val = parseFloat(sensorValue);

  let frac = (val - min) / (max - min);
  frac = frac > 1 ? 1 : frac;
  frac = frac < 0 ? 0 : frac;
  //console.log("Radial ", "min:", min, ", max", max, ", val", val,", frac", frac)
  var endAngle = 0 -(Math.PI / 180) * START_ANGL + frac * (START_ANGL+END_ANGL)*(Math.PI/180);

  // Skala
  let xScale = scaleLinear()
    .domain([min, max])
    .range([0, 1])
    .clamp(true);

  // Limits
  let { lower_limit, upper_limit } = widgetSettings;
  let lower_limit_rel = 0;
  let upper_limit_rel = 1;
  let isInLowerLimit = false;
  let isInUpperLimit = false;

  if (lower_limit) {
    lower_limit_rel = xScale(lower_limit);
    if (frac < lower_limit_rel) {
      isInLowerLimit = true;
    }
  }
  if (upper_limit) {
    upper_limit_rel = xScale(upper_limit);
    if (frac > upper_limit_rel) {
      isInUpperLimit = true;
    }
  }

  //console.log("YY", lower_limit, lower_limit_rel, upper_limit, upper_limit_rel);
  //console.log("RAD min max", min, max)
  //console.log("RAD T", frac, xScale(val))

  var bgarc_path = arc()({
    innerRadius: BASE_RAD ,
    outerRadius: BASE_RAD + TRACK_W ,
    startAngle: -(Math.PI / 180) * START_ANGL,
    endAngle: (Math.PI / 180) * END_ANGL
  });
  var fgarc_path = arc()({
    innerRadius: BASE_RAD,
    outerRadius: BASE_RAD + TRACK_W,
    startAngle: -(Math.PI / 180) * START_ANGL,
    endAngle: endAngle
  });
  var text_path = arc()({
    innerRadius: BASE_RAD + TRACK_W + 7,
    outerRadius: BASE_RAD + TRACK_W + 7,
    startAngle: -(Math.PI / 180) * START_ANGL,
    endAngle: (Math.PI / 180) * END_ANGL
  });

  // Dial
  let dialColor = widgetColor;

  let limitCSSClass = "widgetColor";

  if (isInLowerLimit || isInUpperLimit) {
    limitCSSClass = "colorFlashAnim"
    dialColor = "#ff9800"
  }

  let dialTransform = `rotate(${endAngle * (180 / Math.PI)},50,${CY})`;
  let trianglePoints = `46,${CY - BASE_RAD + 10} 54,${CY -
    BASE_RAD +
    10} 50,${CY - BASE_RAD + 4}`;
  let triangle = (
    <polygon
      points={trianglePoints}
      fill={dialColor}
    />
  );

  let triangleDial = (
    <line
      x1="50"
      x2="50"
      y1={BASE_RAD - 2}
      y2={BASE_RAD + 10}
      stroke={dialColor}
      strokeWidth="0.5"
    />
  );

  let marker = <g transform={dialTransform} className="tt">{triangle} {triangleDial}</g>;

  // End Dial

  // Limits
  let limitArcPath = arc()({
    innerRadius: BASE_RAD - 3,
    outerRadius: BASE_RAD - 1,
    startAngle: -(Math.PI / 180) * START_ANGL,
    endAngle:
      -(Math.PI / 180) * START_ANGL +
      (Math.PI / 180) * (START_ANGL + END_ANGL) * lower_limit_rel
  });
  let limitArc = (
    <path
      d={limitArcPath}
      transform={`translate(50,${CY})`}
      strokeWidth="0"
      fill="#ff9800"
      className={isInLowerLimit ? limitCSSClass : undefined}
    />
  );

  let limitArcPath2 = arc()({
    innerRadius: BASE_RAD - 3,
    outerRadius: BASE_RAD - 1,
    startAngle:
      (Math.PI / 180) * START_ANGL -
      (Math.PI / 180) *
        (START_ANGL + END_ANGL) *
        (1 - upper_limit_rel),
    endAngle: (Math.PI / 180) * END_ANGL
  });
  let limitArc2 = (
    <path
      d={limitArcPath2}
      transform={`translate(50,${CY})`}
      strokeWidth="0"
      fill="#ff9800"
      className={isInUpperLimit ? limitCSSClass : undefined}
    />
  );
  // End Limits

  // Ticks
  let { show_ticks = true } = widgetSettings;

  let xTicks = xScale.ticks(11).map(xScale);

  // TODO: use textpath.
  let tickMarks = show_ticks && xTicks.map((xTick, idx) => {
    let even = idx % 2 === 0;
    //let isFirst = idx === 0;
    //let isLast = idx === xTicks.length - 1;

    let tickTransform = `rotate(${xTick * (START_ANGL + END_ANGL) -
      START_ANGL},50,${CY})`;
    //let textTransform = `rotate(${START_ANGL},50,${CY})`;

    let tickLength = even ? 4 : 2;
    //tickLength += TRACK_W;
    // Make tick color dependent on wether the value has gone poast the tick or not.
    let tickColor = (xTick > frac) ? _lightWidgetColor : widgetColor;
    return (
      <g key={`rt${idx}`}>
        {<line
          className="radialgauge-widget-tickline"
          x1="50"
          x2="50"
          y1={CY - BASE_RAD  }
          y2={CY - BASE_RAD - TRACK_W - tickLength}
          strokeWidth="1"
          transform={tickTransform}
          stroke={tickColor}
        />}
        {even && (
          <text
            x="50"
            y={CY - BASE_RAD - TRACK_W - 7}
            dominantBaseline="baseline"
            textRendering="optimizeLegibility"
            fontSize="0.55em"
            textAnchor="middle"
            transform={tickTransform}
            fontFamily="Helvetica, sans-serif"
            fill="black"
          >
            {xScale.invert(xTick)}
          </text>
        )}
      </g>
    );
  });

  let tickMarksGroup = <g>{tickMarks}</g>;

  //console.log("Radial Gauge Ticks", xTicks)
  // End Skala

  // Special settings
  let showMinMaxLabels = true;
  try {
    showMinMaxLabels = thisWidgetConfig.widgetSettings.show_minmax === true;
  } catch (error) {}

  return (
    <div className="radialgauge-widget">
      <svg
        className="radialgauge-widget-svg"
        viewBox="0 0 100 100"
        width="100%"
        height="100%"
      >
        <defs>
        <pattern id="pattern_VOrulm" patternUnits="userSpaceOnUse" width="1.5" height="1.5" patternTransform="rotate(45)" fill="red">
            <line x1="0" y="0" x2="0" y2="1.5" stroke="#ff9800" strokeWidth="1" />
        </pattern>
        </defs>

        {tickMarksGroup}

        <path d={text_path} id="textpath" transform={`translate(50,${CY})`} />
        <path
          d={bgarc_path}
          id="bgpath"
          className="radialgauge-widget-bgarc"
          transform={`translate(50,${CY})`}
          fill={_lightWidgetColor}
        />
        <path
          d={fgarc_path}
          fill={widgetColor}
          className="radialgauge-widget-fgarc"
          transform={`translate(50,${CY})`}
        />
        {showMinMaxLabels && (
          <text
            dominantBaseline="hanging"
            textAnchor="middle"
            transform="translate(12.5,85)"
            fontSize="8"
          >
            {min}
          </text>
        )}
        {showMinMaxLabels && (
          <text
            dominantBaseline="hanging"
            textAnchor="middle"
            transform="translate(87.5,85)"
            fontSize="8"
          >
            {max}
          </text>
        )}

        {/*dialHub*/}
        {/*dial*/}
        {/*limitCircle*/}

        {limitArc}
        {limitArc2}
        {marker}

      </svg>
    </div>
  );
};

const MockedRadialGauge = wrapMockedWidget(RadialGauge);
export { MockedRadialGauge };
export default wrapWidget(RadialGauge);
